"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fieldset = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const label_1 = require("@nbc-design/label");
const message_1 = require("@nbc-design/message");
const popover_1 = require("@nbc-design/popover");
const tooltip_1 = require("@nbc-design/tooltip");
require("./fieldset.css");
/** Used to group related elements in a form. (Radio/Checkbox/Combo) */
const Fieldset = ({ id, optionalText, tooltip, popover, legend, children, description, introduction, validate, className, dataTest = 'fieldset', length, ...other }) => {
    const classes = (0, classnames_1.default)('dsc-fieldset', length && `is-${length}`, validate?.hasError && 'has-error', className);
    const tooltipMarkup = () => {
        let tooltipReturnMarkup;
        if (tooltip) {
            const { className: tooltipClassName, ariaLabel, ...fwdProps } = tooltip;
            if (tooltip.content)
                tooltipReturnMarkup = ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { ...fwdProps, iIcon: { title: ariaLabel, size: 'medium' }, className: (0, classnames_1.default)('dsc-fieldset__tip', tooltipClassName) }));
        }
        return tooltipReturnMarkup;
    };
    const popoverMarkup = () => {
        let popoverReturnMarkup;
        if (popover) {
            const { className: popoverClassName, ariaLabel, ...fwdProps } = popover;
            if (popover.title && popover.content)
                popoverReturnMarkup = ((0, jsx_runtime_1.jsx)(popover_1.Popover, { ...fwdProps, iIcon: { title: ariaLabel }, className: (0, classnames_1.default)('dsc-fieldset__popover', popoverClassName) }));
        }
        return popoverReturnMarkup;
    };
    const legendMarkup = legend && ((0, jsx_runtime_1.jsxs)(label_1.Label, { type: "legend", optionalText: optionalText, dataTest: "legend", children: [legend, tooltipMarkup(), popoverMarkup()] }));
    const descriptionId = description?.id || (id && `dsc-${id}__description`);
    const descriptionMarkup = description?.text && ((0, jsx_runtime_1.jsx)("span", { id: descriptionId, className: "dsc-fieldset__description", "data-test": "description", children: description.text }));
    const introductionId = introduction?.id || (id && `dsc-${id}__introduction`);
    const introductionMarkup = introduction?.text && ((0, jsx_runtime_1.jsx)("span", { id: introductionId, className: "dsc-fieldset__introduction", "data-test": "introduction", children: introduction.text }));
    const errorMsgId = validate?.id || (id && `dsc-${id}__errorMsg`);
    const errorMsgMarkup = validate?.hasError && validate?.errorMsg && ((0, jsx_runtime_1.jsx)(message_1.Message, { appearance: "error", id: errorMsgId, children: validate.errorMsg }));
    const setAriaDescribedBy = () => {
        let ariaDescribedByValue = '';
        if (validate?.hasError && errorMsgId) {
            ariaDescribedByValue = errorMsgId;
        }
        else if (introduction?.text && introductionId) {
            ariaDescribedByValue = introductionId;
        }
        else if (description?.text && descriptionId) {
            ariaDescribedByValue = descriptionId;
        }
        return ariaDescribedByValue;
    };
    return ((0, jsx_runtime_1.jsxs)("fieldset", { ...other, className: classes, "data-test": dataTest, id: id, "aria-describedby": setAriaDescribedBy(), children: [legendMarkup, introductionMarkup, children, descriptionMarkup, errorMsgMarkup] }));
};
exports.Fieldset = Fieldset;
exports.Fieldset.displayName = 'Fieldset';
//# sourceMappingURL=fieldset.js.map